'use client';

import React from 'react';

import config from 'configs/app';
import buildUrl from 'lib/api/buildUrl';
import useFetch from 'lib/hooks/useFetch';
import useToast from 'lib/hooks/useToast';
import ReCaptcha from 'src/components/shared/reCaptcha/ReCaptcha';
import useReCaptcha from 'src/components/shared/reCaptcha/useReCaptcha';

import AppErrorIcon from '../AppErrorIcon';
import AppErrorTitle from '../AppErrorTitle';
import styles from '../AppError.module.css';

const AppErrorTooManyRequests = () => {
  const toast = useToast();
  const fetch = useFetch();
  const recaptcha = useReCaptcha();

  const handleSubmit = React.useCallback(async() => {
    try {
      const token = await recaptcha.executeAsync();
      const url = buildUrl('api_v2_key');

      await fetch(url, {
        method: 'POST',
        body: { recaptcha_response: token },
        credentials: 'include',
      }, {
        resource: 'api_v2_key',
      });

      window.location.reload();

    } catch (error) {
      toast({
        position: 'top-right',
        title: 'Error',
        description: 'Unable to get client key.',
        status: 'error',
        variant: 'subtle',
        isClosable: true,
      });
    }
  }, [ recaptcha, toast, fetch ]);

  if (!config.services.reCaptchaV2.siteKey) {
    throw new Error('reCAPTCHA V2 site key is not set');
  }

  return (
    <>
      <AppErrorIcon statusCode={ 429 }/>
      <AppErrorTitle title="Too many requests"/>
      <p className={ styles.text }>
        You have exceeded the request rate for a given time period. Please reduce the number of requests and try again soon.
      </p>
      <ReCaptcha ref={ recaptcha.ref }/>
      <button onClick={ handleSubmit } className={ styles.tryAgainButton }>Try again</button>
    </>
  );
};

export default AppErrorTooManyRequests;
